import NotFoundPage from './components/NotFoundPage';
import PageContent from './components/PageContent';
import PageContentDetail from './components/PageContentDetail';
import PageContentLanding from './components/PageContentLanding';
import PageEventDetails from './components/PageEventDetails';
import PageEvents from './components/PageEvents';
import PageGetInvolved from './components/PageGetInvolved';
import PageGetInvolvedApply from './components/PageGetInvolvedApply';
import PageGetInvolvedFeedback from './components/PageGetInvolvedFeedback';
import PageGetInvolvedThanks from './components/PageGetInvolvedThanks';
import PageGoogleForm from './components/PageGoogleForm';
import PageHome from './components/PageHome';
import PageNews from './components/PageNews';
import PageNewsDetail from './components/PageNewsDetail';
import PageOverallMap from './components/PageOverallMap';
import PagePrograms from './components/PagePrograms';
import PageProgramsMap from './components/PageProgramsMap';
import PageProjectDetail from './components/PageProjectDetail';
import PageProjects from './components/PageProjects';
import PageProjectsThanks from './components/PageProjectsThanks';
import PageSearch from './components/PageSearch';
import PopUp from './components/PopUp';
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Page500 from './components/Page500';
import shareImage from './img/share.png';
import PageProjectsExternal from './components/PageProjectsExternal';

// const staticReload = () => window.location.reload();

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level. When making updates to
// this file you may need to reload the page or restart
// `npm start` service to see changes.

class App extends React.Component{
  // constructor(props){
  //   super(props);
  //   this.googleTranslateElementInit = this.googleTranslateElementInit.bind(this);
  // }
  //
  //
  // componentDidMount(){
  //   var addScript = document.createElement('script');
  //   addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
  //   document.body.appendChild(addScript);
  //   window.googleTranslateElementInit = this.googleTranslateElementInit;
  // }
  //
  //
  // googleTranslateElementInit(){
  //   //alert("test2")
  //   /* eslint-disable no-new */
  //   new window.google.translate.TranslateElement({
  //     pageLanguage: 'en',
  //     layout: window.google.translate.TranslateElement.FloatPosition.TOP_LEFT,
  //   }, 'google_translate_element');
  // }


  render(){
    //The NavLinks & Switch can be created via data from the CMS using a for loop

    //images to use somewhere in the site (other images in img folder are dropped)
    shareImage;

    return (
      <>
        <PopUp/>

        <Routes>
          <Route path="/" element={<PageHome/>}/>
          <Route path="/content/:slug" element={<PageContent/>}/>
          <Route path="/content-detail/:slug" element={<PageContentDetail/>}/>
          <Route path="/content-landing/:slug" element={<PageContentLanding/>}/>
          <Route path="/events/:slug" element={<PageEventDetails/>}/>
          <Route path="/events" element={<PageEvents/>}/>
          <Route path="/get-involved" element={<PageGetInvolved/>}/>
          <Route path="/get-involved/apply/:slug" element={<PageGetInvolvedApply/>}/>
          <Route path="/get-involved/feedback" element={<PageGetInvolvedFeedback/>}/>
          <Route path="/get-involved/thanks" element={<PageGetInvolvedThanks/>}/>
          <Route path="/request-bike-rack" element={<PageGoogleForm/>}/>
          <Route path="/news" element={<PageNews/>}/>
          <Route path="/news/:slug" element={<PageNewsDetail/>}/>
          <Route path="/overall-map/maps" element={<PageOverallMap/>}/>
          <Route path="/programs/:slug/maps" element={<PageProgramsMap/>}/>
          <Route path="/programs/:slug" element={<PagePrograms/>}/>
          <Route path="/projects" element={<PageProjects/>}/>
          <Route path="/projects-external" element={<PageProjectsExternal/>}/>
          <Route path="/projects/thanks" element={<PageProjectsThanks/>}/>
          <Route path="/projects/:slug" element={<PageProjectDetail/>}/>
          <Route path="/search" element={<PageSearch/>}/>
          <Route path="/500" element={<Page500/>}/>
          <Route path="*" element={<NotFoundPage/>}/>

          {/*<Route path="/maps/child.html" onEnter={staticReload}/>*/}
        </Routes>
      </>
    );
  }
}

App.propTypes = {
  children: PropTypes.element,
};

export default App;
